import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'
  import { toastUtils } from '../util/toast.utils.js';
  
  export class TimelineTarefasService extends Service {
    constructor(controleDeInstancia) {
      super(controleDeInstancia);
      this.url = env.url + "timeline-tarefas";
      
      this.controladoresDeInstancia = {
        listar: new AbortController(),
        adicionarRegistro: new AbortController()
      }
    }
  
    async listar(objetoDeFiltros, controlador) {
      this.controladoresDeInstancia.listar = this.selecionarControlador(controlador);
      const queryString = this.converterObjetoDeFiltrosParaQueryString(objetoDeFiltros);
      return super.get(`${this.url}` + queryString, this.controladoresDeInstancia.listar);
    }

    async adicionarRegistro(registro, controlador) {
      this.controladoresDeInstancia.adicionarRegistro = this.selecionarControlador(controlador);
      const response = await super.post(this.url, registro, this.controladoresDeInstancia.adicionarRegistro);
      if (response.ok) {
          return response;
      } else {
          toastUtils.dangerToast("Não foi possível adicionar o comentário");
          throw new Error('HTTP ' + response.status);
      }
    }

    async deletarComentario(comentario) {
      const url = `${this.url}/deletar-comentario`;
      const response = await super.delete(url, comentario);
      const messageResponse = await response.json();
      const message = messageResponse.message;
  
      if (response.ok) {
        toastUtils.successToast(message);
        return response;
      } else {
        toastUtils.dangerToast("Ocorreu um erro ao excluir o comentário.");
        throw new Error('HTTP ' + response.status)
      }
    }

    async editarComentario(comentario,controlador) {
      this.controladoresDeInstancia.adicionarRegistro = this.selecionarControlador(controlador);
      const response = await super.patch(this.url, comentario, this.controladoresDeInstancia.adicionarRegistro);
      if (response.ok) {
          return response;
      } else {
          toastUtils.dangerToast("Não foi possível editar o comentário");
          throw new Error('HTTP ' + response.status);
      }
    }
  }
  
  export const timelineTarefasService = new TimelineTarefasService()
  